import gql from 'graphql-tag';

export const ARTICLE_QUERY = gql`
  query ArticleQuery($id: ID!) {
    article(id: $id) {
      id
      url
      fullUrl
      title
      runStatus
      deprecated
      starred
      facebookAccountId
      facebookAdsCount
      facebookPageId
      facebookPage {
        id
        facebookPageId
        facebookPageDisplayName
      }
      storyAudienceMetrics {
        pending
        inProgress
        waitingForActivation
        successful
        failed
        expired
      }
      targetingSelection {
        ageMin
        ageMax
      }
      campaign {
        id
        name
        campaignObjective
        flipperFeatures {
          name
          enabled
        }
        end
        campaignType
        facebookCboEnabled
        publisherId
        defaultUserOs
        defaultUserDevice
        defaultAgeMin
        defaultAgeMax
        defaultGender
        language
        defaultLocalesFromLanguage
        defaultCountries
        defaultRegions
        defaultMediumGeoAreas
        defaultCities
        defaultZipCodes
        defaultBehaviors
        defaultCustomAudiences
        excludedCustomAudiences
        defaultRelationshipStatuses
        configApprovalRequired
        savedAudienceId
        useSavedAudience
        campaignsGoogleConfig {
          id
          campaignType
          startDate
          endDate
          dailyBudget
          bid
          status
          businessName
          urlParams
          minAge
          maxAge
          includeUndeterminedAge
          genders
          includeUndeterminedGender
          targetedLocations {
            id
            canonicalName
            targetType
          }
          googleAccount {
            id
            googleAccountId
            accountName
          }
          campaignsGoogleLogos {
            id
            url
          }
        }
        publisher {
          name
          publisherFacebookAccounts {
            priority
            facebookAccount {
              accountId
              businessId
            }
          }
          facebookAccounts {
            accountId
            timezone
          }
        }
        storyAudienceEnable
        campaignFacebookPages {
          id
          facebookPageId
          facebookPageDisplayName
        }
        pageLockedArticlesEnabled
      }
      articleGroup {
        id
        title
        articleGroupInterests {
          name
          score
          size
          facebookId
        }
      }
      creatives {
        id
        disapprovedAdsStatistic {
          disapprovedCount
          disapprovedRatioPercentage
        }
      }
    }
  }
`;
